import React from 'react';
import { useState } from 'react';

interface Token {
  key: string;
}

function UseVerify({ key }: Token) {
  const [data, setData] = useState('');

  const send = async () => {
    try {
      const response = await fetch('https://djangodrf.arifsultani291.digital/signup/verify/', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body:JSON.stringify({'code':key})
      });

      if (!response.ok) {
        const jsonData = await response.json();
        console.log(jsonData);
      } else {
        const jsonData = await response.json();
        setData(jsonData);
        console.log(jsonData)
      }
    } catch (error: any) {
      console.log(error.message);
    }
  };

  return { data, send };
}

export default UseVerify;
